import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';
import { useDispatch } from "react-redux";
import { login as loginThunk } from "../../state/features/auth/authThunks";

const Login = ({ showCard = true }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            if (!email || !password) {
                throw new Error('Email and password are required');
            }
            await dispatch(loginThunk({ email, password })).unwrap();
            navigate("/dashboard");
        } catch (err) {
            setError(err || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    const formContent = (
        <>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        id="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="your@email.com"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password"
                        required
                    />
                </div>
                <button type="submit" disabled={loading} className="auth-btn">
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </form>
        </>
    );

    if (showCard) {
        return (
            <div className="auth-container">
                <div className="auth-card">
                    <h2>Login</h2>
                    {formContent}
                </div>
            </div>
        );
    }

    return <div className="auth-card">{formContent}</div>;
};

export default Login;
